import { RuleRow } from 'src/components/admin/RuleManagement';
import { LoanChecklist } from 'src/services/loans/types';
import { create } from 'zustand';

interface ChecklistStore {
  currentChecklist: LoanChecklist;
  currentChecklistRules: RuleRow | null;
  existingRules: RuleRow[];
  actions: {
    setCurrentChecklist: (checklist: LoanChecklist) => void;
    setCurrentChecklistRules: (rules: RuleRow | null) => void;
    setExistingRules: (rules: RuleRow[]) => void;
  };
}

export const useChecklistStore = create<ChecklistStore>((set) => ({
  currentChecklist: {} as LoanChecklist,
  currentChecklistRules: null,
  existingRules: [],
  actions: {
    setCurrentChecklist: (checklist: LoanChecklist) =>
      set({ currentChecklist: checklist }),
    setCurrentChecklistRules: (rules: RuleRow | null) =>
      set({ currentChecklistRules: rules }),
    setExistingRules: (rules: RuleRow[]) => set({ existingRules: rules }),
  },
}));
